import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import {
    Container,
} from 'reactstrap'

import Form from './components/Form'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'

import { withRouter } from 'react-router-dom'

const Edit = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setBreadcrumb } = generalContext
    const { id } = useParams()
    const [data, setData] = useState([])

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Clientes`,
            parentLink: '/customers',
            item: `Editar Cliente`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        (async () => {
            setLoading(true)
            const response = await ApiService.getCustomerById(id)

            setData(response.data.customer)
            setLoading(false)
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form data={data} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Edit)